import { useEffect, useState } from "react";
import "./cart.css";
import { Button } from "react-bootstrap";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link } from "react-router-dom";
import Loading from "../../components/loading/loading";
import ProductCartItem from "./ProductCartItem";
import emptyCart from "../../assets/images/empty-cart.svg";
import { axiosTokenInstance } from "../../axiosConfig/axios";

import cartLocation from "../../assets/images/cart-location.svg";
import arrow from "../../assets/images/arrow.svg";
import Note from "../../components/note/note";
import circleAdd from "../../assets/images/product-details/Group 1000001487.svg";
import { DeletePopup } from "../../components/poupup/delete-popup";
import { SaudiRiyal, Trash2 } from "lucide-react";

const Card = () => {
  const navigate = useNavigate();
  const [notes, setNotes] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [cartProductDetails, setCartProductDetails] = useState([]);
  const [restaurantDetails, setRestaurantDetails] = useState({});
  let [quantity, setQuantity] = useState({});
  const [itemTotals, setItemTotals] = useState({});
  const [allTotalPrice, setAllTotalPrice] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const [isClearAllPopupOpen, setIsClearAllPopupOpen] = useState(false);

  // get cart product details
  const getCartDetails = () => {
    axiosTokenInstance.get("connector/api/users/cart").then((res) => {
      // console.log(res.data.data);

      if (res.data?.data) {
        setCartProductDetails(res.data.data.products);
        setRestaurantDetails(res.data.data.location);

        const quantities = {};
        res.data.data.products.forEach((product) => {
          quantities[product.cart_item_id] = product.quantity;
        });
        setQuantity(quantities);
      } else {
        setCartProductDetails([]);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getCartDetails();
  }, []);

  //delete cart product details
  const emptyProductsCart = () => {
    axiosTokenInstance
      .post("/connector/api/users/cart/emptyCart", {})
      .then((res) => {
        if (res.status === 200) {
          toast.success(" تم الحذف بنجاح.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 2000,
          });

          getCartDetails();
        }
      });
  };

  //delete product from cart
  const deleteProduct = (id) => {
    axiosTokenInstance
      .post(`/connector/api/users/cart/removeItem/${id} `, {})
      .then((res) => {
        if (res.status === 200) {
          toast.success(" تم الحذف بنجاح.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 2000,
          });

          getCartDetails();
        }
      });
  };

  // Update quantity for specific product
  const handleQuantityChange = (cart_item_id, newQuantity) => {
    // console.log(cart_item_id, newQuantity);

    setQuantity((prevQuantity) => ({
      ...prevQuantity,
      [cart_item_id]: newQuantity,
    }));
  };

  // prepare data for updating quantity
  const requestUpdateQuantity = Object.entries(quantity).map(
    ([cart_item_id, qty]) => ({
      cart_item_id,
      qty,
    }),
  );

  const updateQuantity = () => {
    axiosTokenInstance
      .post(`/connector/api/users/cart/updateQuantityMulti`, {
        items: requestUpdateQuantity,
      })
      .then((res) => {
        // console.log(res);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      updateQuantity();
    }, 600);

    return () => clearTimeout(timeout); // يمسح التايمر لو حصل تغير قبل ما يعدي الوقت
  }, [quantity]);

  const handleItemTotalPriceChange = (cart_item_id, totalPrice) => {
    setItemTotals((prev) => {
      const updated = {
        ...prev,
        [cart_item_id]: totalPrice, // ✅ استبدال أو إضافة حسب id
      };

      const allTotal = Object.values(updated).reduce(
        (acc, val) => acc + val,
        0,
      );
      setAllTotalPrice(allTotal);
      return updated;
    });
  };

  const table_id = localStorage.getItem("table");
  //to make order
  const handleOrderDoneClick = () => {
    axiosTokenInstance
      .post(`/connector/api/users/order/make-order`, {
        table_id,
        notes,
      })
      .then((res) => {
        // console.log(res.data);
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
        localStorage.setItem("order-id", res.data.order_id);
        if (res.data.status === 200) {
          navigate("/order");
        }
      });
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {/* ✅ Popup 1: حذف منتج واحد */}
          {isDeletePopupOpen && (
            <DeletePopup
              imgPopup={<Trash2 style={{ color: "red" }} size={50} />}
              title="هل تريد بالفعل حذف الصنف؟"
              textBtn="حذف"
              textBtn1="الغاء"
              closePopup={() => {
                setIsDeletePopupOpen(false);
                setSelectedProductId(null);
              }}
              funToDelete={() => {
                deleteProduct(selectedProductId);
                setIsDeletePopupOpen(false);
                setSelectedProductId(null);
              }}
            />
          )}

          {/* ✅ Popup 2: مسح السلة بالكامل */}
          {isClearAllPopupOpen && (
            <DeletePopup
              imgPopup={<Trash2 style={{ color: "red" }} size={50} />}
              title="هل أنت متأكد أنك تريد افراغ سلة التسوق الخاصة بك؟"
              textBtn="حذف"
              textBtn1="الغاء"
              closePopup={() => {
                setIsClearAllPopupOpen(false);
              }}
              funToDelete={() => {
                emptyProductsCart();
                setIsClearAllPopupOpen(false);
              }}
            />
          )}

          {/* ✅ باقي الصفحة (محتوى السلة) */}
          {!isDeletePopupOpen && !isClearAllPopupOpen && !isPopupOpen && (
            <div>
              <div style={{ padding: "0 20px" }}>
                <div>
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "black",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    السلة
                  </h2>
                </div>

                {cartProductDetails?.length > 0 ? (
                  <>
                    {/* Start header about restaurant*/}
                    <div className="ordered-from-restaurant">
                      <h3>تم الطلب من</h3>
                      <hr />
                      <div className="content">
                        <div className="details-container">
                          <img src={cartLocation} alt="cart-location" />
                          <div className="details">
                            <h4>{restaurantDetails?.name}</h4>
                            <p>{restaurantDetails?.address}</p>
                          </div>
                        </div>
                        <Link to="/menu">
                          <img src={arrow} alt="arrow" />
                        </Link>
                      </div>
                    </div>
                    {/* End header about restaurant  */}

                    {/* Start cart products details */}
                    <div className="product-container">
                      <div className="header">
                        <p>تفاصيل الطلب</p>

                        <div
                          style={{ color: "red" }}
                          onClick={() => setIsClearAllPopupOpen(true)}
                        >
                          مسح الكل
                        </div>
                      </div>

                      <hr />

                      {cartProductDetails?.map((product, index) => {
                        return (
                          <ProductCartItem
                            key={product.cart_item_id}
                            productDetails={product}
                            showDivider={index < cartProductDetails.length - 1}
                            quantity={quantity[product.cart_item_id] || 1}
                            setQuantity={(newQty) =>
                              handleQuantityChange(product.cart_item_id, newQty)
                            }
                            getCartDetails={getCartDetails}
                            onDeleteClick={() => {
                              setSelectedProductId(product.cart_item_id);
                              setIsDeletePopupOpen(true);
                            }}
                            onItemTotalPriceChange={handleItemTotalPriceChange}
                          />
                        );
                      })}
                    </div>
                    {/* End cart products details */}

                    {/* Note of products details */}
                    <div
                      style={{
                        backgroundColor: "white",
                        borderRadius: "20px",
                        padding: "20px",
                        margin: "20px 0",
                      }}
                    >
                      <Note
                        notes={notes}
                        setNotes={setNotes}
                        circleAddImg={circleAdd}
                        title="أضف ملاحظاتك علي الطلب"
                        text="أضف ملاحظاتك"
                      />
                    </div>
                    {/* End Note of products details */}

                    {/* Start price details */}

                    <div className="cart-price-details">
                      <h6 style={{ margin: "0", fontSize: "14px" }}>
                        تفاصيل الفاتورة
                      </h6>
                      <hr />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: "#4FAF5A",
                          fontSize: "14px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                          }}
                        >
                          الإجمالي الصافي
                        </p>
                        <p style={{ margin: "0" }}>
                          {allTotalPrice}
                          <SaudiRiyal size={14} />
                        </p>
                      </div>
                    </div>

                    {/* End  price details */}
                  </>
                ) : (
                  <div className="empty-cart">
                    <div className="content">
                      <img src={emptyCart} alt="empty-cart" />
                      <h3>"سلتك خاوية! متى بتطلب؟"</h3>
                      <p>فى انتظار طلبك</p>
                    </div>
                  </div>
                )}

                <ToastContainer />
              </div>

              {cartProductDetails?.length > 0 && (
                <div className="main-content-price-cart">
                  <div className="cart-group-btns">
                    <Button
                      style={{
                        backgroundColor: "#37BD6B",
                        color: "white",
                        border: "none",
                      }}
                      onClick={handleOrderDoneClick}
                    >
                      تأكيد الطلب
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid rgba(211, 211, 211, 1)",
                      }}
                      onClick={() => navigate("/menu")}
                    >
                      اضافة المزيد
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Card;
